/* eslint-disable */
import React from "react";
import {useTranslation} from "react-i18next";
import {FormControl, FormLabel, Typography} from "@mui/material";

const FormLabelPond = ({label, requiredFile, translateLabels, displayError, formExtra}: any): any => {
    const {t} = useTranslation()

    if (!label) {
        return null;
    }

    const labelText = (translateLabels) ? t(label) : label;

    return (
        <FormControl>
            <FormLabel
                sx={{
                    ml: 2,
                    ...((displayError) && {color: 'error.main'}),
                    display: "flex",
                    flexDirection: "column",
                    wordBreak: "break-all"
                }}
            >
                {formExtra && (
                    <Typography variant={'body2'} sx={{color: "primary.main"}}>
                        {formExtra}
                    </Typography>
                )}
                
                <Typography variant={'caption'}>
                    {labelText} {(requiredFile) && '*'}
                </Typography>
            </FormLabel>
        </FormControl>
    );
}

export default FormLabelPond;
